import React, { Component } from 'react';
import PropTypes from 'prop-types';
import 'cropperjs/dist/cropper.css';

import AspectRatioControls from './AspectRatioControls';
import CropperCanvas from './CropperCanvas';
import ImageManipulationControls from './ImageManipulationControls';
import Mixpanel from '../../shared/Mixpanel';
import ThumbnailUpload from './ThumbnailUpload';
import http from '../../shared/http';
import './Cropper.css';

const RATIOS = {
  oneToOne: 1,
  oneNineOneToOne: 1.911 / 1,
  fourToThree: 4 / 3,

  // Aspect ratio of 0 will 'unlock' crop rectangle
  free: 0
};

class ImageCropper extends Component {
  constructor(props) {
    super(props);
    this.cropper = React.createRef();
    this.initialState = {
      aspectRatio: 'free',
      errors: '',
      imageSrc: this.props.imageSrc,
      loadingImage: false,
      rotation: 0
    };
    this.state = this.initialState;
    this.setAspectRatio = this.setAspectRatio.bind(this);
    this.reset = this.reset.bind(this);
    this.rotateImage = this.rotateImage.bind(this);
    this.setAspectRatio = this.setAspectRatio.bind(this);
    this.setThumbnailUrl = this.setThumbnailUrl.bind(this);
    this.setCroppedThumbnail = this.setCroppedThumbnail.bind(this);
    this.setErrors = this.setErrors.bind(this);
  }

  setThumbnailUrl(url) {
    this.setState({
      imageSrc: url
    });
  }

  setAspectRatio(ratio) {
    this.setState({
      aspectRatio: ratio
    });
  }

  setErrors(errors) {
    this.setState({
      errors: errors
    });
  }

  setCroppedThumbnail() {
    Mixpanel.track('Image Cropped');
    const dataURL = this.cropper.getCroppedCanvas().toDataURL('image/jpeg');
    return http
      .post('/thumbnails', {
        image: dataURL
      })
      .then(res => {
        this.props.onCrop(res.data.thumbnail_url);
      })
      .catch(this.setUploadError);
  }

  rotateImage() {
    this.setState(currentState => ({
      rotation: (currentState.rotation + 90) % 360
    }));
  }

  reset() {
    this.setState({ ...this.initialState, imageSrc: '' });
  }

  render() {
    return (
      <div className="upload-image-modal-content p4" id="thumbnail-modal">
        {this.state.errors && (
          <div className="row alert alert-danger">{this.state.errors}</div>
        )}
        {this.state.imageSrc ? (
          <div className="crop-controls" data-testid="thumbnail-crop-container">
            <div className="row text-center mt2">
              <ImageManipulationControls
                reset={this.reset}
                rotateImage={this.rotateImage}
              />
              <AspectRatioControls
                activeAspectRatio={this.state.aspectRatio}
                setAspectRatio={this.setAspectRatio}
              />
              <CropperCanvas
                aspectRatio={RATIOS[this.state.aspectRatio]}
                rotation={this.state.rotation}
                imageSrc={this.state.imageSrc}
                ref={cropper => {
                  this.cropper = cropper;
                }}
              />
            </div>
            <div className="row mt2">
              <button
                className="btn btn-primary mt2"
                onClick={this.setCroppedThumbnail}
              >
                Set Thumbnail
              </button>
            </div>
          </div>
        ) : (
          <ThumbnailUpload
            handleError={this.setErrors}
            setThumbnailUrl={this.setThumbnailUrl}
            setCroppedThumbnailUrl={thumbnailUrl =>
              this.props.onCrop(thumbnailUrl)
            }
            action={this.props.action}
          />
        )}
      </div>
    );
  }
}

ImageCropper.propTypes = {
  onCrop: PropTypes.func.isRequired,
  imageSrc: PropTypes.string,
  action: PropTypes.string.isRequired
};

ImageCropper.defaultProps = {
  imageSrc: ''
};

export default ImageCropper;
